/* eslint-disable no-unused-vars */
export enum Themes {
  PINK = 'theme__pink',
  BLUE = 'theme__blue',
  GREEN = 'theme__green',
  YELLOW = 'theme__yellow'
}
/* eslint-disable no-unused-vars */
